import { Icon } from '@iconify/react';
import type { PadelRotationFormat, TambahPadelGameFormState } from './padelGenerateUtils';

interface TambahPadelGameFormatFieldsProps {
  form: TambahPadelGameFormState;
  confirmedCount: number;
  onChange: (patch: Partial<TambahPadelGameFormState>) => void;
}

const FORMATS: {
  value: PadelRotationFormat;
  icon: string;
  title: string;
  hint: string;
}[] = [
  {
    value: 'americano',
    icon: 'mdi:shuffle-variant',
    title: 'Americano',
    hint: 'Pasangan diacak tiap ronde, semua pemain bertemu semua pemain.',
  },
  {
    value: 'mexicano',
    icon: 'mdi:trophy-variant-outline',
    title: 'Mexicano',
    hint: 'Pasangan ronde berikutnya ditentukan peringkat poin ronde sebelumnya.',
  },
  {
    value: 'round_robin',
    icon: 'mdi:format-list-numbered',
    title: 'Round Robin',
    hint: 'Pasangan tetap, setiap pasangan bertemu semua pasangan lain sekali.',
  },
];

export default function TambahPadelGameFormatFields({
  form,
  confirmedCount: _confirmedCount,
  onChange,
}: TambahPadelGameFormatFieldsProps) {
  return (
    <div className="rounded-3xl border border-gray-100 bg-white p-4 sm:p-5 shadow-2xs">
      <h2 className="text-base font-extrabold text-[#0E1726]">Format Penyusunan</h2>
      <div className="mt-3.5 space-y-2.5">
        {FORMATS.map((opt) => {
          const selected = form.rotationFormat === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              aria-label={opt.title}
              aria-pressed={selected}
              onClick={() => onChange({ rotationFormat: opt.value })}
              className={`w-full rounded-2xl p-3.5 text-left flex items-center justify-between gap-3.5 transition-all cursor-pointer ${
                selected
                  ? 'border-2 border-[#FC480D] bg-[#FFF8F5]'
                  : 'border border-gray-100 bg-white hover:border-gray-200'
              }`}
            >
              <div
                className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl transition-colors ${
                  selected
                    ? 'bg-white border border-orange-100 text-[#FC480D]'
                    : 'bg-gray-50 text-gray-400'
                }`}
              >
                <Icon icon={opt.icon} className="h-5 w-5" />
              </div>
              <div className="min-w-0 flex-1">
                <p className="text-sm font-extrabold text-[#0E1726]">{opt.title}</p>
                <p className="text-xs text-gray-400 mt-0.5 leading-relaxed">{opt.hint}</p>
              </div>
              {selected ? (
                <Icon icon="mdi:check-circle" className="h-5 w-5 text-[#FC480D] shrink-0" />
              ) : (
                <Icon icon="mdi:check-circle" className="h-5 w-5 text-gray-200 shrink-0" />
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
}
